import { DEFAULT_AMOUNT } from '../../containers/CreateACard'
import { v4 as uuidv4 } from 'uuid'

function CustomCard() {
    this.cardId = uuidv4()
    this.cardNetwork = {}
    this.amount = DEFAULT_AMOUNT
    this.quantity = 1
    this.nameOnCard = ''
    this.messageOnCard = ''
    this.carrierFrom = ''
    this.carrierMessage = ''
    this.recipientName = ''
    this.addressLine1 = ''
    this.addressLine2 = ''
    this.city = ''
    this.state = ''
    this.zip = ''
    this.shippingMethod = ''
    this.compositeBackgroundImage = ''
    this.previewImage = ''
    this.background = ''
    this.backgroundZoom = 1
    this.backgroundX = 0
    this.backgroundY = 0
    this.cloudinaryId = ''
}

export default CustomCard
